


































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
     Sections
 ---------------------------------------- */

import Articles from '@part/generic/Articles.vue';
import CallToAction from '@part/generic/CallToAction.vue';
import CaseOverview from '@part/generic/CaseOverview.vue';
import Highlight from '@part/generic/Highlight.vue';
import Logos from '@part/generic/Logos.vue';
import RelatedPages from '@part/generic/RelatedPages.vue';
import Welcome from '@part/home/Welcome.vue';

/* ----------------------------------------
    Module Helper
---------------------------------------- */

import { StoreModule } from "@store/service/Modules";
const module = new StoreModule('cases');

/* ----------------------------------------
     Helpers
 ---------------------------------------- */

import { loader } from '@util/images';

/* ----------------------------------------
    JS Module
---------------------------------------- */

import { Opening } from '@js/module/Opening';

/* ----------------------------------------
     Transitions
 ---------------------------------------- */

import * as transition from '@router/transitions/generic/fade'

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    components: {
        Articles,
        CallToAction,
        CaseOverview,
        Highlight,
        Logos,
        RelatedPages,
        Welcome,
    },

    computed: {
        content() {
            return this.template('home');
        }
    },

    mounted() {
        const open = new Opening();
        const projects = module.getters('getCaseFeaturedImages');

        loader(projects.featured)
            .then(() => {
                const app = document.querySelector('#app');
                transition.fadeIn(app, 250, 500);

                open.init().then(() => {
                    loader(projects.header);
                });
            });
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Home extends Vue {}

